<div class="dropdown"
     appDropdownAutoLocate
     [rect]="{left:-13}"
     [menuWidth]="data.rect.width"
     [dropdownWidth]="data.width">
    <app-box-arrow [color]="'#2f2e4d'"></app-box-arrow>
    <div class="line">

    </div>
    <div class="line bg">
        <div class="block" *ngIf="user.officalUp">
            <!-- <img [src]="'./assets/images/officalUp.png' | absUrl" class="groupid" /><span class="g bigVip">大V</span> -->
            <app-membership-icon
                style="margin-left: -2px;"
                [membership]="'bigV'"
                [noText]="false" [newIcon]="true"
                [canHover]="true" [textML]="true">
            </app-membership-icon>
        </div>
        <div class="d-flex justify-content-between" *ngIf="!user.officalUp && user.daysOfMembership==0" style="width: 100%;">
            <div >
                <h5 class="h5">还不是VIP会员？</h5>
            </div>
            <div >
                <span (click)="showRechargeBox()"
                class="dn-button dn-button-red">立即开通</span>
            </div>
        </div>
        <div class="block" *ngIf="!user.officalUp && user.daysOfMembership>0">
            <!-- <img src="{{user.mBadge|absUrl}}" class="groupid" /><span class="g">{{user.groupName}}</span> -->
            <app-membership-icon
                style="margin-left: 1px;"
                [membership]="user.membership"
                [noText]="false" [newIcon]="true"
                [canHover]="true" [textML]="true">
            </app-membership-icon>
            <div class="leftdays pull-right fs-12">剩余<span>{{user.daysOfMembership}}</span>天</div>
            <!-- <div >
                <h5 class="h5">还不是VIP会员？</h5>
            </div>
            <div >
                <span (click)="showRechargeBox()"
                class="dn-button dn-button-red">立即开通</span>
            </div> -->
        </div>
    </div>


    <div class="discountbox d-flex align-items-center" *ngIf="!!discountList && discountList.length >0">
        <!-- <div class="discountinfo">限时特惠</div> -->
        <div class="discountinfo">惠</div>
        <div>
            <div class="discountcontent" *ngFor="let item of discountList">{{item.info}}</div>
        </div>
    </div>
    <a [routerLink]="['/', 'vip-center', 'index']" [queryParams]="{r:2}">
        <div class="d-flex align-items-center mb-2">
            <span class="vip-right vip-adfree x1" [ngClass]="{'light': !isDark}"></span>
            <span class="fs-12">过滤广告</span>
        </div>
    </a>

    <a *ngIf="!isAdult" [routerLink]="['/', 'vip-center', 'index']" [queryParams]="{r:1}">
        <div class="d-flex align-items-center my-2">
           <span class="vip-right vip-4K x1" [ngClass]="{'light': !isDark}"></span>
           <span class="fs-12">观看超清视频</span>
        </div>
    </a>

    <a *ngIf="isAdult" [routerLink]="['/', 'vip-center', 'index']" [queryParams]="{r:1}">
        <div class="d-flex align-items-center my-2">
           <span class="vip-right vip-4K x1" [ngClass]="{'light': !isDark}"></span>
           <span class="fs-12">观看步兵片</span>
        </div>
    </a>

    <a [routerLink]="['/', 'vip-center', 'index']" [queryParams]="{r:6}">
        <div class="d-flex align-items-center my-2">
            <span class="vip-right vip-download x1" [ngClass]="{'light': !isDark}"></span>
            <span class="fs-12">下载视频</span>
        </div>
    </a>

    <a *ngIf="isAdult" [routerLink]="['/', 'vip-center', 'index']" [queryParams]="{r:2}">
        <div class="d-flex align-items-center my-2">
            <span class="vip-right vip-4K x1" [ngClass]="{'light': !isDark}"></span>
            <span class="fs-12">超大收藏夹</span>
        </div>
    </a>

    <a *ngIf="!isAdult" [routerLink]="['/', 'vip-center', 'index']" [queryParams]="{r:3}">
        <div class="d-flex align-items-center my-2">
           <span class="vip-right vip-qiupian x1" [ngClass]="{'light': !isDark}"></span>
           <span class="fs-12">求片</span>
        </div>
    </a>

    <a [routerLink]="['/', 'vip-center', 'index']" [queryParams]="{r:7}">
        <div class="d-flex align-items-center my-2">
            <span class="vip-right vip-zungui x1" [ngClass]="{'light': !isDark}"></span>
            <span class="fs-12">尊贵身份标识</span>
        </div>
    </a>
    <div class="mt-4 gothere fs-12" *ngIf="user.id>0">
        <a [routerLink]="'/vip-center/index'" class="d-flex align-items-center pull-right" *ngIf="user.daysOfMembership>0">
            前往VIP专区<span class="iconfont iconchakangengduo fs-16"></span>
        </a>
        <a [routerLink]="'/vip-center/index'" class="d-flex align-items-center pull-right"
          *ngIf="user.daysOfMembership==0">
            前往VIP专区<span class="iconfont iconchakangengduo fs-16"></span>
        </a>

        <!-- <div (click)="showRechargeBox()"
             class="dn-button dn-button-red">立即开通</div> -->
    </div>
</div>
